module.exports = __webpack_public_path__ + "static/media/WB_Drinking.6a16253e.png";